import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface AuthGuardProps {
  children: ReactNode;
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const { user, loading, hasBusiness } = useAuth();
  const location = useLocation();

  if (loading || (user && hasBusiness === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-2xl overflow-hidden animate-pulse">
            <img
              src="https://storage.readdy-site.link/project_files/3da75122-8c1c-4e05-bb8b-0bbdfa25568f/77be6b44-7bba-43ed-a1ae-cb71d6f2b97a_polatlar-appico.jpg"
              alt="Polatlar Mobilya"
              className="w-full h-full object-contain"
            />
          </div>
          <p className="text-sm text-foreground-400 font-sans">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Hesabı var ama henüz hiçbir işletmeye üye değil — onboarding'e yönlendir.
  if (hasBusiness === false) {
    return <Navigate to="/signup" state={{ step: 'business' }} replace />;
  }

  return <>{children}</>;
}